export const eventsConst = {
    EVENTS_REQUEST: 'EVENTS_REQUEST',
    EVENTS_SUCCESS: 'EVENTS_SUCCESS',
    EVENTS_FAILURE: 'EVENTS_FAILURE',
};
